export default __webpack_public_path__ + "static/media/drsandeep.195bc9bb.jpg";